// extracted by mini-css-extract-plugin
export default {"modalOverlay":"KD-z","modalContent":"LD-z","header":"MD-z","close":"ND-z"};